// A project's slot switcher, and the banner that names a shadow slot
// (docs/Y2026-Q4/design-agent-configs.md section 11).
import { DEFAULT_SLOT } from "../api/agentSlot";
import { type AgentSlot, useBranchedAt } from "../api/hooks/useAgentConfigs";
import { slotName, slotOrigin } from "../utils/agentSlotText";
import styles from "./AgentSlotBar.module.css";

export const AgentSlotSwitcher = ({
  slots,
  slot,
  onChoose,
}: {
  slots: AgentSlot[];
  slot: string;
  onChoose: (slot: string) => void;
}) => (
  <label className={styles.switcher}>
    <span className={styles.switcherLabel}>Configuration</span>
    <select
      className={styles.select}
      value={slot}
      onChange={(e) => onChoose(e.target.value)}
    >
      {slots.map((s) => (
        <option key={s.slot} value={s.slot}>
          {slotName(s)}
          {s.status === "paused" ? " (paused)" : ""}
        </option>
      ))}
    </select>
  </label>
);

export const AgentSlotBanner = ({ slot }: { slot: AgentSlot }) => {
  if (slot.slot === DEFAULT_SLOT && slot.status === "active") return null;
  return (
    <div className={styles.banner} role="note">
      {slot.slot !== DEFAULT_SLOT && (
        <p className={styles.line}>
          <strong>{slotName(slot)}</strong>, {slotOrigin(slot)}. Shadow: nothing it writes
          leaves this view.
        </p>
      )}
      {slot.status === "paused" && (
        <p className={styles.line}>
          Paused{slot.paused_reason ? `: ${slot.paused_reason}` : ""}.
        </p>
      )}
    </div>
  );
};

/** Beside a link to the run that wrote something: in a branched slot, a row from before the
 * branch was written by default's run, not this slot's. */
export const WrittenBeforeBranch = ({ at }: { at: string | null | undefined }) => {
  const branchedAt = useBranchedAt();
  if (!at || !branchedAt || new Date(at) >= new Date(branchedAt)) return null;
  return <span className={styles.beforeBranch}> (written in default before the branch)</span>;
};
